module.exports = __webpack_public_path__ + "img/medical-assistant.977e9631.svg";